<template>
  <div class="infoBeamsWrap">
    <div class="infoBeamsWrap-info" @click.prevent="show">
      i
    </div>
    <Modal title="Типы балок MS PRO" :is-show="isShow" @close="close">
      <div class="beamsTypes-table">
        <div class="beamsTypes-head beamsTypes-row">
          <div class="cell">
            Характеристики
          </div>
          <div class="cell">
            b-образная
          </div>
          <div class="cell">
            z-образная
          </div>
        </div>
        <div class="beamsTypes-row">
          <div class="cell">
            Профиль балки
          </div>
          <div class="cell">
            <img src="beams-b.png" />
          </div>
          <div class="cell">
            <img src="beams-z.png" />
          </div>
        </div>
        <div class="beamsTypes-row">
          <div class="cell">
            Высота балки/<br/>
            высота балки с полкой, мм
          </div>
          <div class="cell">
            75/75
          </div>
          <div class="cell">
            80/114
          </div>
        </div>
        <div class="beamsTypes-row">
          <div class="cell">
            Нанесение брендированного <br/>
            штампа на балку
          </div>
          <div class="cell">
            Да
          </div>
          <div class="cell">
            Нет
          </div>
        </div>
        <div class="beamsTypes-row">
          <div class="cell">
            Толщина металла
          </div>
          <div class="cell">
            1,5 мм
          </div>
          <div class="cell">
            1,2 мм
          </div>
        </div>
        <div class="beamsTypes-row">
          <div class="cell">
            Установка полок яруса<br/>
            вровень с балкой
          </div>
          <div class="cell">
            Да
          </div>
          <div class="cell">
            Нет
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-white"
        @click="close"
      >
        <span>Закрыть</span>
      </button>
    </Modal>
  </div>
</template>

<script>
  import Modal from './Modal.vue';

  export default {
    components: {
      Modal,
    },
    data() {
      return {
        isShow: false
      };
    },
    mounted() {
      
    },
    methods: {
      show() {
        this.isShow = true
      },
      close() {
        this.isShow = false
      },
    },
  };
</script>

<style scoped>
  .infoBeamsWrap {
    position: absolute;
    display: inline-block;
    margin-left: 16px;
    margin-top: 2px;
    text-transform: none;
    font-size: 14px;
    font-family: Roboto, sans-serif;
  }
  .infoBeamsWrap-info {
    display: block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    color: white;
    background: #333333;
    cursor: pointer;
  }
  .beamsTypes-table {
    margin-bottom: 30px;
    font-size: 14px;
    width: 700px;
  }
  .beamsTypes-head {
    background-color: #F6F6F6;
  }
  .beamsTypes-row {
    display: flex;
    padding: 24px 0 24px 20px;
    border-top: 1px solid #DDDDDD;
    border-bottom: 1px solid #DDDDDD;
  }
  .beamsTypes-row .cell:first-child {
    flex-grow: 1;
    text-align-last: left;
  }
  .beamsTypes-row .cell:nth-child(n+2) {
    width: 200px;
    text-align: center;
  }
  button {
    width: auto;
    cursor: pointer;
  }
  button.btn-white {
    background-color: transparent;
    color: #F58214;
    border: 2px solid #F58214;
  }
</style>
